import classNames from 'classnames';
import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';
import { getImageUrl } from '@/src/assets/utils/getImageUrl';
import { getUpdateDate } from '@/src/assets/utils/getUpdateDate';

import NextImage from '../../UI/nextImage/NextImage';
import { Title } from '../../UI/title/Title';

import styles from './BlogFeaturedPost.module.scss';

interface BlogFeaturedPostProps {
    featPostData: BlogPostInterface;
}

const BlogFeaturedPost: FC<BlogFeaturedPostProps> = ({ featPostData }) => {
    return (
        <article className={styles.featuredPost}>
            <a href={`/blog/${featPostData.slug}`} className={styles.featuredPostImageWrapperLink}>
                <NextImage
                    className={styles.featuredPostImage}
                    src={getImageUrl(featPostData.image)}
                    alt={featPostData.image.alt || 'Featured Post Image'}
                    quality={90}
                    fill={true}
                    priority={true}
                    sizes="(max-width: 1100px) 93vw, (max-width: 1920px) 52vw, (min-width: 1921px) 1032px"
                />
            </a>
            <div className={styles.featuredPost__contentWrapper}>
                <div className={styles.featuredPost__tags}>
                    {featPostData.tags?.map((tag) => {
                        return (
                            <a
                                href={`/blog/tag/${tag.slug}`}
                                key={tag._id}
                                className={styles.featuredPost__tag}>
                                {tag.title}
                            </a>
                        );
                    })}
                </div>

                <Title size="md" className={styles.featuredPost__title}>
                    {' '}
                    <a
                        className={styles.featuredPost__titleLink}
                        href={`/blog/${featPostData.slug}`}>
                        {featPostData.title}
                    </a>
                </Title>
                <p className={classNames('excerpt body-lg', styles.featuredPost__excerpt)}>
                    {featPostData.excerpt}
                </p>
                <span className={styles.featuredPost__date}>
                    {getUpdateDate(featPostData._updatedAt)}
                </span>
            </div>
        </article>
    );
};

export { BlogFeaturedPost };
